import { CountrySelectionDto } from 'types/dtos/country-selection'
import { CountrySelectionModel } from 'types/models/country-selection'

export const transformCountrySelectionDto = (
  countryDto: CountrySelectionDto,
): CountrySelectionModel => ({
  code: countryDto.code,
  title: countryDto.title,
  flagUrl: countryDto.flag_url,
})

export const transformCountriesSelectionDtos = (
  countryDtos: Array<CountrySelectionDto>,
): Array<CountrySelectionModel> => countryDtos.map(transformCountrySelectionDto)
